import { Button, Icon } from "@chakra-ui/react";
import React from "react";
import { FaArrowRight } from "react-icons/fa";
import ArtisanSmiling from "../../assets/artisan-smiling.png";
import LadyInGlasses from "../../assets/lady-in-glasses.png";

type BuiltForSkilledWorkersSectionProps = {
  sectionText: string;
  handleCTAClick: () => void;
  ctaText: string;
};

export default function BuiltForSkilledWorkersSection({
  sectionText,
  handleCTAClick,
  ctaText,
}: BuiltForSkilledWorkersSectionProps) {
  return (
    <>
      <section className="grid grid-cols-1 gap-0 w-full">
        <div className="bg-[#121212] w-full px-3 lg:px-20 py-8 lg:py-16 flex flex-row lg:flex-col items-end lg:items-start gap-12 border-[#121212] border-r-[1px] border-b-[1px]">
          <div className="flex flex-col gap-6 lg:w-[40%] xl:w-[45%]">
            <h1 className="text-2xl lg:text-6xl font-medium text-[#FEFEFE] lg:leading-[72px]">
              {sectionText}
            </h1>
          </div>
          <div className="w-full lg:w-[50%] flex justify-end lg:justify-start">
            <Button
              backgroundColor={"#FEFEFE"}
              color={"#040A0D"}
              paddingY={{
                base: 6,
                lg: 10,
              }}
              w={{
                base: "93%",
                lg: "60%",
              }}
              fontSize={{
                base: 14,
                lg: 22,
              }}
              rightIcon={
                <Icon
                  as={FaArrowRight}
                  w={{
                    base: 4,
                    lg: 5,
                  }}
                  h={5}
                  ml={2}
                  className="animate-wiggle"
                />
              }
              onClick={() => handleCTAClick()}
            >
              {ctaText}
            </Button>
          </div>
        </div>
        <div className="hidden">
          <div className="w-full grid grid-cols-2 lg:grid-cols-3 gap--1">
            <div className="hidden lg:flex items-end bg-[#F5B700] h-full border-[#121212] border-b-[1px] border-r-[1px]">
              <img
                src={LadyInGlasses}
                alt="Lady in glasses"
                className="lg:brightness-0 lg:hover:brightness-100"
              />
            </div>
            <div className="flex items-end bg-[#F5B700] h-full border-[#121212] border-b-[1px] border-r-[1px]">
              <img
                src={ArtisanSmiling}
                alt="Artisan smiling"
                className="lg:brightness-0 lg:hover:brightness-100"
              />
            </div>
            <div className="flex items-end bg-[#F5B700] h-full border-[#121212] border-b-[1px] border-r-[1px]">
              <img
                src={LadyInGlasses}
                alt="Lady in glasses"
                className="lg:brightness-0 lg:hover:brightness-100"
              />
            </div>
            <div className="hidden lg:flex items-end bg-[#F5B700] h-full border-[#121212] border-b-[1px] border-r-[1px]">
              <img
                src={ArtisanSmiling}
                alt="Artisan smiling"
                className="lg:brightness-0 lg:hover:brightness-100"
              />
            </div>
            <div className="flex items-end bg-[#F5B700] h-full border-[#121212] border-b-[1px] border-r-[1px]">
              <img
                src={LadyInGlasses}
                alt="Lady in glasses"
                className="lg:brightness-0 lg:hover:brightness-100"
              />
            </div>
            <div className="flex items-end bg-[#F5B700] h-full border-[#121212] border-b-[1px] border-r-[1px]">
              <img
                src={ArtisanSmiling}
                alt="Artisan smiling"
                className="lg:brightness-0 lg:hover:brightness-100"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
